/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AdvancedSearchModalController {
   $location: any
   $scope: any
   $uibModalInstance: any
   advancedSearch: AdvancedSearchService
   closeAdvancedSearch: any
   dialogService: any
   constructor($scope: any, $uibModalInstance: any, advancedSearch: AdvancedSearchService, dialogService: DialogService, $location: any) {
      this.clearAdvancedSearchForm = this.clearAdvancedSearchForm.bind(this)
      this.submitAdvancedSearch = this.submitAdvancedSearch.bind(this)
      this.$scope = $scope
      this.$uibModalInstance = $uibModalInstance
      this.advancedSearch = advancedSearch
      this.dialogService = dialogService
      this.$location = $location
      this.$scope.closeAdvancedSearch = this.closeAdvancedSearch
      this.$scope.clearAdvancedSearchForm = this.clearAdvancedSearchForm
      this.$scope.submitAdvancedSearch = this.submitAdvancedSearch
   }

   $onInit() {
      if (this.$scope.searchScopeService.hasSearchScopes) {
         this.advancedSearch.resetSearchscope()
      }
         
      return this.$uibModalInstance.result
      // not handling errors in dialog closing, just catch the close
         .then((res: any) => {
            return this.$scope.viewState.subView = ''
         }).catch((res: any) => {
            return this.$scope.viewState.subView = ''
         })
   }

   clearAdvancedSearchForm($event: any) {
      //Focus the first advanced search field after clearing the search.
      //We have to do it like this because all the fields are dynamically
      //generated and any directive would apply to all
      $event.preventDefault()
      this.advancedSearch.clear()
      return angular.element('#searchValue0').focus()
   }

   submitAdvancedSearch() {
      // needed when advanced search initiated from home page, currentView would need to change from home to search
      this.$scope.viewState.currentView = 'search' 
      this.$scope.resetNewSearchFlag()
      this.dialogService.closeModalDialog()
      if(! this.$location.$$path.includes('/search')) { 
         this.$location.path('/search')
      }
      this.advancedSearch.submit()
   }
}

AdvancedSearchModalController.$inject = ['$scope', '$uibModalInstance', 'advancedSearchService', 'dialogService', '$location']

angular.module('summonApp.controllers')
   .controller('AdvancedSearchModalCtrl', AdvancedSearchModalController)
